import { EXAMTYPE_SAVE_API,EXAMTYPE_ENABLE_API,EXAMTYPE_API} from '../resource/index';
import axios from '../config/axios.config';
export default {

   async save(params) {
      return await axios.save(EXAMTYPE_SAVE_API,{},params);
   },
  async enableOrDisable(params) {
    return await axios.update(EXAMTYPE_ENABLE_API,params,{});
  },
  async fetchData(id) {
    return await axios.get(EXAMTYPE_API,{id:id});
  }


}



// WEBPACK FOOTER //
// ./src/service/examtypeService.js